// Campanhas promocionais com data de início/fim — centralizado aqui para
// serem fáceis de encontrar, ajustar ou desativar quando terminarem.

// Setembro de 2026: sem custo de inscrição nas aulas para quem se inscrever
// durante o mês.
// Ritual de Outono & Sound Healing (7 de novembro de 2026): pop-up na Home.
// Aparece até 6 de novembro e deixa de aparecer no dia 7 (dia do evento).
export function eventoRitualOutonoAtivo() {
  const hoje = new Date().toISOString().slice(0, 10);
  return hoje >= '2026-10-28' && hoje < '2026-11-07';
}

// Natal de 2026: vale-presente. Para mudar o período, basta alterar as datas
// (formato AAAA-MM-DD); fora deste intervalo a barra e a secção desaparecem sozinhas.
export function campanhaNatalAtiva() {
  const hoje = new Date().toISOString().slice(0, 10);
  return hoje >= '2026-10-15' && hoje <= '2026-12-24';
}

export function campanhaSetembroAtiva() {
  const hoje = new Date().toISOString().slice(0, 10);
  return hoje >= '2026-09-01' && hoje <= '2026-09-30';
}
